import $ from 'jquery';

var searchAutocompleteContainer = $('.search-suggestions');
var searchInputFieldMobile = $('.search-input-mobile');

searchAutocompleteContainer.hide();

var timeout = 0;

var get_suggestions = function (input, auto, collectionOnly = false) {
	$.ajax({
		dataType: "json",
		url: seats.suggest_url,
		data: {
			collectionOnly: collectionOnly,
			data: input.val()
		},
		method: 'GET',
		success: function (response) {
			if (response.data === undefined) {
				auto.hide();
				return;
			}
			var data = response.data;
			if (data.length === 0) {
				auto.hide();
				return;
			}

			auto.find('ul').empty();
			$.each(data, function (key, item) {
				var resultTitle = item.text.replace(new RegExp(input.val(), "ig"), input.val());
				auto.find('ul').append('<li><a href="' + item.url + '" class="search-suggestions__link">' + resultTitle + '<br><span class="search-suggestions__taxonomy '+ (item.offer ? 'search-suggestions__taxonomy--offer' : '') +'">' + item.category + '</span></a></li>');
			});

			auto.show();
		},
		error: function () {
			auto.hide();
		}
	});
};

$(document).on('input', '.header__search-wrapper-input', function() {
	var searchAutocompleteContainer = $(this).next('.search-suggestions');

	if ($(this).val().length > 2) {
		clearTimeout(timeout);
		timeout = setTimeout(get_suggestions($(this), searchAutocompleteContainer), 200);

	} else {
		searchAutocompleteContainer.hide();
		searchAutocompleteContainer.find('ul').empty();
	}
});


$(document).on('input', '.collection-search__wrapper .facetwp-search', function() {
	var searchAutocompleteContainer = $(this).parents('.collection-search__wrapper').find('.search-suggestions');

	if ($(this).val().length > 2) {
		clearTimeout(timeout);
		timeout = setTimeout(get_suggestions($(this), searchAutocompleteContainer, true), 200);
	} else {
		searchAutocompleteContainer.hide();
		searchAutocompleteContainer.find( 'ul' ).empty();
	}
});

searchInputFieldMobile.on('input click', function () {
	if ($(this).val().length > 2) {
		clearTimeout(timeout);
		timeout = setTimeout(get_suggestions(searchInputFieldMobile, searchAutocompleteContainer), 200);
	} else {
	searchAutocompleteContainer.hide();
	searchAutocompleteContainer.find('ul').empty();
}

});

$('body').on('click', function (evt) {
	if (searchAutocompleteContainer.is(":hidden")) {
		return;
	}
	if (evt.target.id === ".header__search-wrapper-input")
		return;
	//For descendants of .header__search-wrapper-input being clicked
	if ($(evt.target).closest('.header__search-wrapper-input').length)
		return;

	searchAutocompleteContainer.hide();
});

$('body').on('click', function (evt) {
	if (searchAutocompleteContainer.is(":hidden")) {
		return;
	}
	if (evt.target.id === ".mobile")
		return;
	//For descendants of .header__search-wrapper-input being clicked
	if ($(evt.target).closest('.header__search-wrapper-input').length)
		return;

	searchAutocompleteContainer.hide();
});